export default {
  auth: {
    signUp: {
      title: "Create an account",
      email: "Email address",
      password: "Password",
      confirmPassword: "Confirm password",
      submit: "Sign up",
      loading: "Signing up in progress...",
      alreadyHaveAccount: "Already registered? Sign in",
      confirmationSent: "A confirmation email has been sent",
    },
    login: {
      title: "Sign in",
      email: "Email address",
      password: "Password",
      submit: "Sign in",
      loading: "Signing in progress...",
      forgotPassword: "Forgot password?",
      noAccount: "Not registered yet? Create an account",
      language: "Language",
    },
    forgotPassword: {
      title: "Forgot password",
      email: "Email address",
      submit: "Send reset link",
      loading: "Sending...",
      backToLogin: "Back to login",
      successMessage: "A reset email has been sent",
    },
    resetPassword: {
      title: "Reset password",
      password: "New password",
      confirmPassword: "Confirm new password",
      submit: "Reset password",
      loading: "Resetting...",
      success: "Your password has been successfully reset! You can now log in.",
    },
    confirmEmail: {
      title: "Email confirmation required",
      verifying: "Verifying...",
      invalidLink: "Invalid link",
      backToLogin: "Back to login",
      successMessage: "Your account has been activated",
    },
    errors: {
      generic: "An error occurred. Please try again.",
      invalidEmail: "Invalid email",
      passwordRequired: "Password is required",
      passwordLength: "Password must contain at least 8 characters",
      passwordFormat:
        "Password must contain at least one uppercase letter, one lowercase letter and one number",
      passwordMatch: "Passwords do not match",
      noAdminAccess: "Unauthorized access",
      invalidToken: "Invalid or expired link",
      samePassword: "The new password must be different from the previous one",
    },
  },
};
